export const SALES_AND_COMMISSION_CONSTANTS = {
  TITLE: "Sales and commission",
  COMMISSION_LABEL: "Commission till now",
  SALES_LABEL: "Sales made",
  DEFAULT_COMMISSION: "0",
  DEFAULT_SALES_COUNT: 0,
  DEFAULT_SALES_AMOUNT: "0",
  DEFAULT_CURRENCY_SYMBOL: "₹",
  DECIMAL_PRECISION: 2,
  PERCENTAGE_MULTIPLIER: 100,
  SINGLE_COUNT_THRESHOLD: 1,
  SALES_TEXT_SINGULAR: "sale",
  SALES_TEXT_PLURAL: "sales",
  SEPARATOR: "•",
};
